









import { Component, Vue } from "vue-property-decorator";
import Banner from "@/components/pages/home/Banner.vue";
import TopMerchantContainer from "@/components/merchants/TopMerchantContainer.vue";
import TopCouponCardContainer from "@/components/coupons/TopCouponCardContainer.vue";
import TopArticles from "@/components/pages/home/TopArticles.vue";
import { mapGetters } from "vuex";

@Component({
  components: {
    Banner,
    TopArticles,
    TopMerchantContainer,
    TopCouponCardContainer
  },
  computed: {
    ...mapGetters("app", ["isLangDetected"])
  }
})
export default class Home extends Vue {
  isLangDetected: false;

  created() {
    if (this.isLangDetected) {
      this.$store.dispatch("home/updateHomeFromAPI");
    } else {
      this.$store.subscribe(mutation => {
        if (mutation.type === "app/setCurrentLang") {
          this.$store.dispatch("home/updateHomeFromAPI");
        }
      });
    }
  }
}
